import PropTypes from "prop-types";
import React from "react";
import { ContextMenuTrigger } from "react-contextmenu";

import { BREAKPOINT_SMALL } from "config/constants";
import { CONTENT_TYPE_TO_URL } from "config/constants/editor";
import getEditorURL from "editor/utils/getEditorURL";

import DashboardStorySmall from "./DashboardStorySmall";
import DashboardStoryLarge from "./DashboardStoryLarge";

export default class DashboardStory extends React.Component {
  constructor(props) {
    super(props);

    this.onSizeChange = this._onSizeChange.bind(this);
    this.mediaQuery = window.matchMedia(BREAKPOINT_SMALL);

    // Set the initial state for the size of component based on a media query.
    this.state = {
      size: this.getSize(this.mediaQuery),
    };
  }

  /**
   * When the component mounts, bind an event listener that changes its rendering when the media
   * query matches/unmatches
   */
  componentDidMount() {
    this.mediaQuery.addListener(this.onSizeChange);
  }

  /**
   * Remember to remove the listener when the component unmounts.
   */
  componentWillUnmount() {
    this.mediaQuery.removeListener(this.onSizeChange);
  }

  _onSizeChange(e) {
    this.setState({ size: this.getSize(e) });
  }

  /**
   * @param {MediaQueryList} mediaQuery
   */
  getSize(mediaQuery) {
    return mediaQuery.matches ? "large" : "small";
  }

  render() {
    const { story, showPublishedDatetime } = this.props;

    return (
      <ContextMenuTrigger
        id="StoryMenu"
        collect={props => props}
        status={story.status}
        url={getEditorURL(CONTENT_TYPE_TO_URL[story.content_type], story.id)}
        isFeatured={story.is_featured}
        publishedLink={story.permalink}
      >
        {this.state.size === "large" ? (
          <DashboardStoryLarge
            story={story}
            showPublishedDatetime={showPublishedDatetime}
          />
        ) : (
          <DashboardStorySmall
            story={story}
            showPublishedDatetime={showPublishedDatetime}
          />
        )}
      </ContextMenuTrigger>
    );
  }
}

DashboardStory.propTypes = {
  story: PropTypes.object.isRequired,
  showPublishedDatetime: PropTypes.func.isRequired,
};
